export enum EvaluationMeasurement {
  WORKSPACE = 'DH',
  DESK_HEIGHT = 'L',
  MONITOR_HEIGHT = 'MH',
  FOCAL_DISTANCE = 'FD',
  REACH_TO_PHONE = 'RP',
  CUSTOM = 'OM',
}
